(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-hero-mobile"] && !Shopify.designMode) return;
  try {
    
  // Mobile-only horizontal motion. No-ops on desktop (where the section is hidden).
  (function(){
    const init = (root) => {
      if (!root || root.dataset.tllInit === '1') return;
      root.dataset.tllInit = '1';

      const mobileQuery = window.matchMedia('(max-width: 768px)');
      // If NOT mobile, do nothing (desktop is hidden by CSS).
      if (!mobileQuery.matches) { root.classList.add('is-ready'); return; }

      const heroSection = root.querySelector('.hero');
      if (!heroSection) { root.classList.add('is-ready'); return; }

      const parallaxElements = root.querySelectorAll('[data-speed]');
      const bearLayer = root.querySelector('.hero__characters--bear');
      const foxLayer  = root.querySelector('.hero__characters--fox');

      const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      let motionAllowed = !reduceMotionQuery.matches;

      let heroTop = 0, heroHeight = 0, ticking = false;
      const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

      const recalc = () => {
        const r = heroSection.getBoundingClientRect();
        heroTop = r.top + window.scrollY;
        heroHeight = Math.max(r.height, 1);
      };

      const render = () => {
        parallaxElements.forEach(el => el.style.setProperty('--parallax-y', '0px'));
        if (!motionAllowed) {
          if (bearLayer) bearLayer.style.setProperty('--offset-x', '0px');
          if (foxLayer)  foxLayer.style.setProperty('--offset-x',  '0px');
          ticking = false; return;
        }
        const distance = clamp(window.scrollY - heroTop, 0, heroHeight * 1.5);
        const progress = clamp(distance / heroHeight, 0, 1.5);

        if (bearLayer) {
          const sx = parseFloat(bearLayer.dataset.speedX || '1');
          const mx = parseFloat(bearLayer.dataset.maxShiftX || '2000');
          const x = clamp(-(progress * sx * heroSection.clientWidth), -mx, 0);
          bearLayer.style.setProperty('--offset-x', x + 'px');
        }
        if (foxLayer) {
          const sx = parseFloat(foxLayer.dataset.speedX || '1');
          const mx = parseFloat(foxLayer.dataset.maxShiftX || '2000');
          const x = clamp(progress * sx * heroSection.clientWidth, 0, mx);
          foxLayer.style.setProperty('--offset-x', x + 'px');
        }
        ticking = false;
      };

      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(render); } };
      const onResize = () => { recalc(); render(); };
      const onMotion = (e) => { motionAllowed = !e.matches; render(); };

      recalc(); render(); root.classList.add('is-ready');

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
      if (typeof reduceMotionQuery.addEventListener === 'function') reduceMotionQuery.addEventListener('change', onMotion);
      else if (typeof reduceMotionQuery.addListener === 'function') reduceMotionQuery.addListener(onMotion);
      window.addEventListener('load', () => { recalc(); render(); });
    };

    document.querySelectorAll('.tll-hero').forEach(init);
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-hero"] && !Shopify.designMode) return;
  try {
    
// Desktop & Mobile initializers are separate; each only runs at its breakpoint.
(function(){
  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

  function makeRenderer(root) {
    const heroSection = root.querySelector('.hero');
    const parallaxElements = root.querySelectorAll('[data-speed]');
    const bearLayer = root.querySelector('.hero__characters--bear');
    const foxLayer  = root.querySelector('.hero__characters--fox');

    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let motionAllowed = !reduceMotionQuery.matches;

    let heroTop = 0, heroHeight = 0, ticking = false;

    const recalc = () => {
      if (!heroSection) return;
      const r = heroSection.getBoundingClientRect();
      heroTop = r.top + window.scrollY;
      heroHeight = Math.max(r.height, 1);
    };

    const render = () => {
      parallaxElements.forEach(el => el.style.setProperty('--parallax-y', '0px'));
      if (!motionAllowed || !heroSection) {
        if (bearLayer) bearLayer.style.setProperty('--offset-x', '0px');
        if (foxLayer)  foxLayer.style.setProperty('--offset-x',  '0px');
        ticking = false; return;
      }
      const distance = clamp(window.scrollY - heroTop, 0, heroHeight * 1.5);
      const progress = clamp(distance / heroHeight, 0, 1.5);

      if (bearLayer) {
        const sx = parseFloat(bearLayer.dataset.speedX || '1');
        const mx = parseFloat(bearLayer.dataset.maxShiftX || '2000');
        const x = clamp(-(progress * sx * heroSection.clientWidth), -mx, 0);
        bearLayer.style.setProperty('--offset-x', x + 'px');
      }
      if (foxLayer) {
        const sx = parseFloat(foxLayer.dataset.speedX || '1');
        const mx = parseFloat(foxLayer.dataset.maxShiftX || '2000');
        const x = clamp(progress * sx * heroSection.clientWidth, 0, mx);
        foxLayer.style.setProperty('--offset-x', x + 'px');
      }
      ticking = false;
    };

    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(render); } };
    const onResize = () => { recalc(); render(); };
    const onMotion = (e) => { motionAllowed = !e.matches; render(); };

    return {
      mount() {
        recalc(); render(); root.classList.add('is-ready');
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize, { passive: true });
        if (typeof reduceMotionQuery.addEventListener === 'function') reduceMotionQuery.addEventListener('change', onMotion);
        else if (typeof reduceMotionQuery.addListener === 'function') reduceMotionQuery.addListener(onMotion);
        window.addEventListener('load', () => { recalc(); render(); });
      }
    };
  }

  function initDesktop(root) {
    if (!root || root.dataset.tllInitDesktop === '1') return;
    if (!window.matchMedia('(min-width: 769px)').matches) { root.classList.add('is-ready'); return; }
    root.dataset.tllInitDesktop = '1';
    makeRenderer(root).mount();
  }

  function initMobile(root) {
    if (!root || root.dataset.tllInitMobile === '1') return;
    if (!window.matchMedia('(max-width: 768px)').matches) { root.classList.add('is-ready'); return; }
    root.dataset.tllInitMobile = '1';
    makeRenderer(root).mount();
  }

  document.querySelectorAll('.tll-hero--desktop').forEach(initDesktop);
  document.querySelectorAll('.tll-hero--mobile').forEach(initMobile);
})();

  } catch(e) { console.error(e); }
})();
})();
